module.exports = __webpack_public_path__ + "static/media/3.e3d57745.jpg";